module.exports = require("./ky-KG");